import { useEffect } from 'react';

var useGlobalKeyPress = function useGlobalKeyPress(targetKey, callback) {
  useEffect(function () {
    var handleGlobalKeyPress = function handleGlobalKeyPress(e) {
      var key = e.key;
      switch (key) {
        case targetKey:
          callback(e);
          break;
      }
    };
    document.addEventListener('keydown', handleGlobalKeyPress, true);
    return function () {
      document.removeEventListener('keydown', handleGlobalKeyPress, true);
    };
  }, [targetKey, callback]);
};

export { useGlobalKeyPress };
